var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"export-data-options":_vm.exportDataOptions,"showSearchbox":_vm.showSearchbox,"showGroupActions":_vm.showGroupActions,"expand-config":{ lazy: true, loadMethod: _vm.fetchPolicies }}})
}
var staticRenderFns = []

export { render, staticRenderFns }